import React, { useEffect } from 'react'
import NavbarTop from '../components/global/NavbarTop'
import HomeContent from '../components/Home/HomeContent'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from './../redux/language/selector';



const Home = () => {
    const {t} = useTranslation()

    const language = useSelector(selectLanguage)

    useEffect(() => {
        document.title = t('home-page.home-title')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[language])
    return (
        
        <div>
            <NavbarTop/>
            <HomeContent/>
            {/* <Footer/>
            <NavbarBottom/>       */}
        </div>
    )
}

export default Home